import { useEffect, useRef } from "react";
import { useAppDispatch } from "../store/hooks";
import { useIdleTimer } from "./useIdleTimer";
import {
  resetUseSessionMessage,
  showUserSessionMessage,
} from "../store/slices/UserSessionMessageSlice";
import {
  TIMEOUT_LIMIT_FOR_SESSION_MESSAGE,
  TIMEOUT_LIMIT_FOR_SESSION_POPUP,
  SESSION_LOGOUT_COMPLETE_LOCAL_STORAGE_KEY,
  SESSION_LOGOUT_LOCAL_STORAGE_KEY,
} from "../Constant";
import { getUserLogout } from "../store/slices/UserLogoutSlice";
import {
  getAccessTokenFromLocal,
  removeOpportunityCodeFromLocal,
} from "../utils/common";
const useSessionPopup = () => {
  const dispatch = useAppDispatch();
  const logoutStarted = useRef(false);

  const { time, isIdle } = useIdleTimer({
    timeout: TIMEOUT_LIMIT_FOR_SESSION_MESSAGE,
  });

  useEffect(() => {
    const handleLogoutSync = (event: StorageEvent) => {
      if (
        event.key === SESSION_LOGOUT_LOCAL_STORAGE_KEY &&
        event.newValue !== null
      ) {
        logoutStarted.current = true;
      }

      if (
        event.key === SESSION_LOGOUT_COMPLETE_LOCAL_STORAGE_KEY &&
        event.newValue?.endsWith(":failed")
      ) {
        logoutStarted.current = false;
      }
    };

    window.addEventListener("storage", handleLogoutSync);
    return () => window.removeEventListener("storage", handleLogoutSync);
  }, []);

  useEffect(() => {
    const accessToken = getAccessTokenFromLocal();
    if (!accessToken || accessToken === "" || accessToken === null) {
      logoutStarted.current = false;
      return;
    }
    if (isIdle) {
      if (logoutStarted.current) {
        return;
      }

      logoutStarted.current = true;
      dispatch(resetUseSessionMessage());
      dispatch(getUserLogout());
      removeOpportunityCodeFromLocal();
      window.SN_CSM_EC?.close();
      return;
    }
    //  console.log("🚀 ~ TIMEOUT_LIMIT_FOR_SESSION_MESSAGE:, TIMEOUT_LIMIT_FOR_SESSION_POPUP, time", TIMEOUT_LIMIT_FOR_SESSION_MESSAGE, TIMEOUT_LIMIT_FOR_SESSION_POPUP, time, TIMEOUT_LIMIT_FOR_SESSION_MESSAGE - TIMEOUT_LIMIT_FOR_SESSION_POPUP);

    logoutStarted.current = false;
    if (
      time >
        TIMEOUT_LIMIT_FOR_SESSION_MESSAGE - TIMEOUT_LIMIT_FOR_SESSION_POPUP &&
      !isIdle
    ) {
      dispatch(showUserSessionMessage());
    }
  }, [isIdle, time, dispatch]);

  return { time, isIdle };
};

export default useSessionPopup;
